import {
  getApiToken,
  getActiveAccount
} from '~/utils/cookie'

import applyAuthInterceptor, { isUnauthenticatedAuthRequest } from '~/utils/axios-auth-interceptor'
import { mapToApiLanguage } from '~/utils/language'

export default function (context) {
  const { $axios, $config, store } = context

  $axios.onRequest((config) => {
    const token = getApiToken()
    const account = getActiveAccount()
    const language = mapToApiLanguage(store.state.language)
    const appVersion = $config.APP_VERSION

    // Do not send leftover session cookies on login/2FA requests. An expired
    // Authorization or ActiveAccount header can make a valid code look like a 401.
    const attachSession = !isUnauthenticatedAuthRequest(config.url, config.method)

    if (token && attachSession) {
      config.headers.common.Authorization = `Bearer ${token}`
    }

    if (account && attachSession) {
      config.headers.common.ActiveAccount = account
    }

    if (language) {
      config.headers.common['Accept-Language'] = language
      config.headers.common['X-Language'] = language
    }

    if (appVersion) {
      config.headers.common['X-App-Version'] = appVersion
    }
  })

  // handle 401 cases
  applyAuthInterceptor(context)
}
